export const hextupleMime = "application/hex+x-ndjson";
